<template>
  <div id="signin"
    class="tile is-ancestor is-parent">
    <!-- <div class="tile is-ancestor is-parent"
    style="height: 100%"
    :style="{ 'background-image': 'url(' + require('@/assets/images/background.jpg') + ')' }"> -->

    <div class="tile is-parent is-vertical">
      <article class="tile is-child detail-page-tile is-4 is-self-centered">
        <figure class="image">
          <img src="@/assets/images/flexiquote-logo-tagline-white.svg"
            class="center"
            style="height: auto; width: 360px;">
        </figure>
      </article>
      <article class="tile is-child box detail-page-tile is-4 is-self-centered">
        <p class="title">Sign In</p>
        <InstallButton />
        <div class="field">
          <div class="control has-icons-left">
            <input type="text"
              v-model="companyLoginId"
              class="input"
              placeholder="Company ID"
              v-mask="companyIdMask" />
            <span class="icon is-left">
              <i class="mdi mdi-account-group mdi-18px"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <input type="text"
              v-model="username"
              class="input"
              placeholder="Username" />
            <span class="icon is-left">
              <i class="mdi mdi-account mdi-18px"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <password-input v-model="password"
            placeholder="Password"
            aria-placeholder="Password"
            @keyup.enter.native="signIn()" />
        </div>
        <div class="buttons">
          <button class="button is-fullwidth is-primary"
            :disabled="!canSignIn"
            @click="signIn()">Sign In</button>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import PasswordInput from '@/components/BulmaPasswordInput'
import { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'
import CryptoJS from 'crypto-js'
import platform from 'platform'
import InstallButton from './InstallButton.vue'

export default {
  name: 'SignIn',
  directives: {
    mask
  },
  components: {
    PasswordInput,
    InstallButton
  },
  data: () => {
    return {
      companyIdMask: '##########',
      companyLoginId: '',
      username: '',
      password: '',
      isSigningIn: false
    }
  },
  computed: {
    canSignIn() {
      return this.companyLoginId !== '' && this.username !== '' && this.password !== ''
    }
  },
  watch: {},
  created() {
    document.title = this.$route.meta.title
  },
  mounted() {},
  methods: {
    ...mapActions(['setJwtToken']),
    async signIn() {
      if (!this.canSignIn) {
        return
      }
      this.$showSpinner('Signing In...')
      // console.log(platform.os)
      const passwordSalt = await this.$auth.testConnection(this.companyLoginId, this.username)
      const hash = CryptoJS.SHA1(`${this.password}${passwordSalt}`)
      const hashedPassword = hash.toString(CryptoJS.enc.Hex)
      const credential = {
        companyLoginId: this.companyLoginId,
        deviceId: this.deviceId,
        username: this.username,
        password: hashedPassword,
        machineId: '',
        osId: platform.os.toString(),
        browserId: `${platform.name} ${platform.version}`,
        location: ''
      }

      const jwtToken = await this.$auth.signIn(credential)
      // console.log(jwtToken)
      await this.setJwtToken(jwtToken)
      await this.getUserInfo()
      this.$router.push('/imageuploader')
      this.$hideSpinner()
    }
  }
}
</script>

<style lang="scss" scope>
#signin {
  background: url('../../assets/images/background.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow: hidden;
  height: 102vh;
}
.is-self-centered {
  align-self: center;
}
.center {
  display: block;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>